import {Id} from 'Common/Id';
import {AccessArea} from 'Common/permissions/AccessArea';

export abstract class Role
{
	constructor(
		readonly name:string,
	)
	{ }

	public abstract topAccess(): AccessArea;

	public abstract canAccessArea(area:AccessArea,siteId:Id):boolean;

	public amManager(_artistId:Id):boolean { return false; }

	public abstract toJson(): any;
}

